// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_R7pug {
}
.header_dN3qO {
  padding : 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom: 5px solid var( --background );
}

.leftIcon_RoONW {
  font-size : 26px;
  width : 54px;
  padding : 10px;
  color : #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.indicator_mSX7_ {

}

@keyframes pulsate_D9Brf {
  from { font-style: 14px; }
  to { font-size:18px; }
}

.status-started_CvI57 {
  NOanimation-name:pulsate_D9Brf;
  animation-duration: 0.5s;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
}

.screen_YdrWs .addDevice_UnDqG {
  border-radius:50%;
  width : 40px;
  height : 40px;
}

.count_TJd_A {
  color : var( --light-grey );
  font-size: 11px;
  padding-left: var( --size-padMedium, 8px);
}

.left_amXX2 {
  position : absolute;
  top : 0;
  bottom : 0;
  right : 0;
  left : 0;
  min-width : 400px;
}

.left_amXX2 .pagination_OJ6ne { 
  border-top : 1px solid var( --lighter-grey );
  background: white;
  position:absolute;
  bottom : 0;
  margin : 0;
  height : 40px;
  width : 100%;
  display: flex;
  justify-content:center;
  align-items:center;
}

.left_amXX2 .innerPagination_TU5jk {
  margin : 0
}



.left_amXX2 .list_uFncJ {
  width:100%;
  height: calc( 100% - 40px );
  top : 0;
  bottom : 40px;
}


.right_GMfFA { 
  position :relative;
  height:100%;
  overflow-y:auto;
  background:var( --background );
  border-left : 1px solid var( --border-color );
  width:400px;
}

.subtitle_uLDoj {
  display : flex;
  flex-direction : row;
  justify-content: space-between;
  align-items : center;
  padding-right:20px;
}


.loading_YvADV {
  color : var( --pink );
  font-size : var( --font-size-large );
  position:absolute;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  width : 100%;
  height: 100%;
  background : rgb( 255,255,255,0.6);
}

.loading_YvADV div { 
  margin : 10px
}

.noItems_dM8aK {
  text-align:left;
  padding: 20px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/device/style.css"],"names":[],"mappings":"AAEA;AACA;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;AAEA;;AAEA;EACE,OAAO,gBAAgB,EAAE;EACzB,KAAK,cAAc,EAAE;AACvB;;AAEA;EACE,8BAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;AACF;;;;AAIA;EACE,UAAU;EACV,2BAA2B;EAC3B,OAAO;EACP,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["@import \"../../style/theme.css\";\n\n.content {\n}\n.header {\n  padding : 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom: 5px solid var( --background );\n}\n\n.leftIcon {\n  font-size : 26px;\n  width : 54px;\n  padding : 10px;\n  color : #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.indicator {\n\n}\n\n@keyframes pulsate {\n  from { font-style: 14px; }\n  to { font-size:18px; }\n}\n\n.status-started {\n  NOanimation-name:pulsate;\n  animation-duration: 0.5s;\n  animation-direction: alternate-reverse;\n  animation-iteration-count: infinite;\n}\n\n.screen .addDevice {\n  border-radius:50%;\n  width : 40px;\n  height : 40px;\n}\n\n.count {\n  color : var( --light-grey );\n  font-size: 11px;\n  padding-left: var( --size-padMedium, 8px);\n}\n\n.left {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  right : 0;\n  left : 0;\n  min-width : 400px;\n}\n\n.left .pagination { \n  border-top : 1px solid var( --lighter-grey );\n  background: white;\n  position:absolute;\n  bottom : 0;\n  margin : 0;\n  height : 40px;\n  width : 100%;\n  display: flex;\n  justify-content:center;\n  align-items:center;\n}\n\n.left .innerPagination {\n  margin : 0\n}\n\n\n\n.left .list {\n  width:100%;\n  height: calc( 100% - 40px );\n  top : 0;\n  bottom : 40px;\n}\n\n\n.right { \n  position :relative;\n  height:100%;\n  overflow-y:auto;\n  background:var( --background );\n  border-left : 1px solid var( --border-color );\n  width:400px;\n}\n\n.subtitle {\n  display : flex;\n  flex-direction : row;\n  justify-content: space-between;\n  align-items : center;\n  padding-right:20px;\n}\n\n\n.loading {\n  color : var( --pink );\n  font-size : var( --font-size-large );\n  position:absolute;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  width : 100%;\n  height: 100%;\n  background : rgb( 255,255,255,0.6);\n}\n\n.loading div { \n  margin : 10px\n}\n\n.noItems {\n  text-align:left;\n  padding: 20px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_R7pug`,
	"header": `header_dN3qO`,
	"leftIcon": `leftIcon_RoONW`,
	"indicator": `indicator_mSX7_`,
	"status-started": `status-started_CvI57`,
	"pulsate": `pulsate_D9Brf`,
	"screen": `screen_YdrWs`,
	"addDevice": `addDevice_UnDqG`,
	"count": `count_TJd_A`,
	"left": `left_amXX2`,
	"pagination": `pagination_OJ6ne`,
	"innerPagination": `innerPagination_TU5jk`,
	"list": `list_uFncJ`,
	"right": `right_GMfFA`,
	"subtitle": `subtitle_uLDoj`,
	"loading": `loading_YvADV`,
	"noItems": `noItems_dM8aK`
};
export default ___CSS_LOADER_EXPORT___;
